/* eslint-disable no-comments/disallowComments */
import { RecordStatus, WebhookStatus } from '@fleet-beat/api';
import { OrderBy } from '@fleet-beat/core';

export interface GetManyV2Dto {
  boundingBox?: string;
  orderBy?: string;
  filterLocallyBy?: string;
  order?: OrderBy;
  limit?: number;
  offset?: number;
  address?: number;
  search?: string;
  include?: string;
  statuses?: string;
  status?: string;
  expirationDate?: string;
  companyIds?: string;
  companyId?: string;
  forCompanyId?: string;
  manufacturer?: string;
  providerType?: string;
  roles?: string;
  tenantIds?: string;
  createdAt?: string;
  logsDateRange?: string;
  dateRange?: string;
  date?: string;
  recordStatuses?: RecordStatus;
  sort?: string;
  from?: string;
  severity?: string;
  to?: string;
  eventType?: string;
  total?: number;
  isActive?: boolean;
  isLocked?: boolean;
  includeSystem?: boolean;
  itemIds?: string;
  original?: boolean;
  driverId?: string;
  driverIds?: string;
  truckIds?: string;
  product?: string;
  type?: string;
  perPage?: number;
  page?: number;
  intervalSeconds?: number;
}

// потрібно зробити рефакторинг, всі унікальні поля вивести в окремі інтерфейси там де воно потрібно !!!!!!!!!!!!!!!!
